import { getCompanyFormClsx } from "../helpers";
import { useCompanyFormState } from "../store";
import type { ICompanyFormProps } from "../types";

export default function ErrorMessage(props: ICompanyFormProps) {
  const { errorMessage } = useCompanyFormState();

  if (!errorMessage) return null;

  const message = String(props[`${errorMessage}ErrorMessage`] || errorMessage);

  return (
    <div
      className={
        getCompanyFormClsx("main", "error") + " texts__body_text--bold"
      }
    >
      {message}
    </div>
  );
}
